"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../common/utils.js");

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = require("../BackgroundColorContext");

var _Typography = _interopRequireDefault(require("../typography/Typography"));

var _uuid = require("uuid");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var expandLess = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "m7.4 15.375-1.4-1.4 6-6 6 6-1.4 1.4-4.6-4.6Z"
}));

var expandMore = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "m12 15.375-6-6 1.4-1.4 4.6 4.6 4.6-4.6 1.4 1.4Z"
}));

var DxcAccordion = function DxcAccordion(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      defaultIsExpanded = _ref.defaultIsExpanded,
      isExpanded = _ref.isExpanded,
      icon = _ref.icon,
      _ref$assistiveText = _ref.assistiveText,
      assistiveText = _ref$assistiveText === void 0 ? "" : _ref$assistiveText,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      children = _ref.children,
      margin = _ref.margin,
      padding = _ref.padding,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = (0, _react.useState)((0, _uuid.v4)()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      id = _useState2[0];

  var _useState3 = (0, _react.useState)(defaultIsExpanded !== null && defaultIsExpanded !== void 0 ? defaultIsExpanded : false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      innerIsExpanded = _useState4[0],
      setInnerIsExpanded = _useState4[1];

  var colorsTheme = (0, _useTheme["default"])();

  var handleAccordionState = function handleAccordionState() {
    var _isExpanded;

    isExpanded !== null && isExpanded !== void 0 ? isExpanded : setInnerIsExpanded(function (innerIsExpanded) {
      return !innerIsExpanded;
    });
    onChange === null || onChange === void 0 ? void 0 : onChange((_isExpanded = !isExpanded) !== null && _isExpanded !== void 0 ? _isExpanded : !innerIsExpanded);
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.accordion
  }, /*#__PURE__*/_react["default"].createElement(AccordionContainer, {
    isExpanded: isExpanded !== null && isExpanded !== void 0 ? isExpanded : innerIsExpanded,
    padding: padding,
    margin: margin
  }, /*#__PURE__*/_react["default"].createElement(AccordionHeader, null, /*#__PURE__*/_react["default"].createElement(AccordionTrigger, {
    id: "accordion-".concat(id),
    onClick: disabled ? undefined : handleAccordionState,
    disabled: disabled,
    tabIndex: disabled ? -1 : tabIndex,
    "aria-expanded": isExpanded !== null && isExpanded !== void 0 ? isExpanded : innerIsExpanded,
    "aria-controls": "accordion-panel-".concat(id),
    isExpanded: isExpanded !== null && isExpanded !== void 0 ? isExpanded : innerIsExpanded
  }, /*#__PURE__*/_react["default"].createElement(AccordionInfo, {
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(AccordionLabel, null, icon && /*#__PURE__*/_react["default"].createElement(IconContainer, {
    disabled: disabled
  }, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement(IconImg, {
    src: icon
  }) : icon), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: disabled ? colorsTheme.accordion.disabledTitleLabelFontColor : colorsTheme.accordion.titleLabelFontColor,
    fontFamily: colorsTheme.accordion.titleLabelFontFamily,
    fontSize: colorsTheme.accordion.titleLabelFontSize,
    fontStyle: colorsTheme.accordion.titleLabelFontStyle,
    fontWeight: colorsTheme.accordion.titleLabelFontWeight,
    lineHeight: "1.5em"
  }, label)), assistiveText && /*#__PURE__*/_react["default"].createElement(AccordionAssistiveText, {
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: disabled ? colorsTheme.accordion.disabledAssistiveTextFontColor : colorsTheme.accordion.assistiveTextFontColor,
    fontFamily: colorsTheme.accordion.assistiveTextFontFamily,
    fontSize: colorsTheme.accordion.assistiveTextFontSize,
    fontStyle: colorsTheme.accordion.assistiveTextFontStyle,
    fontWeight: colorsTheme.accordion.assistiveTextFontWeight,
    letterSpacing: colorsTheme.accordion.assistiveTextLetterSpacing,
    lineHeight: "1.5em"
  }, assistiveText))), /*#__PURE__*/_react["default"].createElement(CollapseIndicator, {
    disabled: disabled
  }, (isExpanded !== null && isExpanded !== void 0 ? isExpanded : innerIsExpanded) ? expandLess : expandMore))), (isExpanded !== null && isExpanded !== void 0 ? isExpanded : innerIsExpanded) && /*#__PURE__*/_react["default"].createElement(AccordionPanel, {
    id: "accordion-panel-".concat(id),
    role: "region",
    "aria-labelledby": "accordion-".concat(id),
    padding: padding
  }, /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.accordion.backgroundColor
  }, children))));
};

var calculateWidth = function calculateWidth(margin) {
  return "calc(100% - ".concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")");
};

var AccordionContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: ", ";\n  ", "\n  box-shadow: ", ";\n  min-width: 280px;\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  width: ", ";\n"])), function (props) {
  return props.theme.backgroundColor;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.isExpanded && "border-bottom-left-radius: 0; border-bottom-right-radius: 0;";
}, function (props) {
  return "".concat(props.theme.boxShadowOffsetX, " ").concat(props.theme.boxShadowOffsetY, " ").concat(props.theme.boxShadowBlur, " ").concat(props.theme.boxShadowColor);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
}, function (props) {
  return calculateWidth(props.margin);
});

var AccordionHeader = _styledComponents["default"].h3(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  min-height: 48px;\n  margin: 0;\n"])));

var AccordionTrigger = _styledComponents["default"].button(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n  background-color: transparent;\n  border: none;\n  border-radius: ", ";\n  ", "\n  padding: 12px 16px;\n  cursor: ", ";\n\n  :focus {\n    outline: ", ";\n  }\n  :hover:enabled {\n    background-color: ", ";\n  }\n  :active:enabled {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.isExpanded && "border-bottom-left-radius: 0; border-bottom-right-radius: 0;";
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return "".concat(props.theme.focusBorderColor, " ").concat(props.theme.focusBorderStyle, " ").concat(props.theme.focusBorderThickness);
}, function (props) {
  return "".concat(props.theme.hoverBackgroundColor);
}, function (props) {
  return "".concat(props.theme.hoverBackgroundColor);
});

var AccordionInfo = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  justify-content: space-between;\n  width: 100%;\n"])));

var AccordionLabel = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-right: ", ";\n  padding-left: ", ";\n"])), function (props) {
  return props.theme.titleLabelPaddingTop;
}, function (props) {
  return props.theme.titleLabelPaddingBottom;
}, function (props) {
  return props.theme.titleLabelPaddingRight;
}, function (props) {
  return props.theme.titleLabelPaddingLeft;
});

var IconContainer = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: ", ";\n  width: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  color: ", ";\n"])), function (props) {
  return props.theme.iconSize;
}, function (props) {
  return props.theme.iconSize;
}, function (props) {
  return props.theme.iconMarginLeft;
}, function (props) {
  return props.theme.iconMarginRigth;
}, function (props) {
  return props.disabled ? props.theme.disabledIconColor : props.theme.iconColor;
});

var IconImg = _styledComponents["default"].img(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.theme.iconSize;
}, function (props) {
  return props.theme.iconSize;
});

var AccordionAssistiveText = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  min-width: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n"])), function (props) {
  return props.theme.assistiveTextMinWidth;
}, function (props) {
  return props.theme.assistiveTextPaddingLeft;
}, function (props) {
  return props.theme.assistiveTextPaddingRight;
});

var CollapseIndicator = _styledComponents["default"].span(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  color: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledArrowColor : props.theme.arrowColor;
});

var AccordionPanel = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n"])), function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) !== "object" ? _variables.spaces[props.padding] : "0px";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.top ? _variables.spaces[props.padding.top] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.right ? _variables.spaces[props.padding.right] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.bottom ? _variables.spaces[props.padding.bottom] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.left ? _variables.spaces[props.padding.left] : "";
});

var _default = DxcAccordion;
exports["default"] = _default;